import { createClient } from '@supabase/supabase-js'

const rawUrl  = import.meta.env.VITE_SUPABASE_URL
const rawAnon = import.meta.env.VITE_SUPABASE_ANON_KEY

const PLACEHOLDER_URL  = 'https://placeholder.supabase.co'
const PLACEHOLDER_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.placeholder.placeholder'

const looksValidUrl = (u) =>
  typeof u === 'string' && /^https?:\/\/[^<>\s]+$/.test(u)

const url  = looksValidUrl(rawUrl) ? rawUrl : PLACEHOLDER_URL
const anon = (typeof rawAnon === 'string' && rawAnon && !rawAnon.includes('<'))
  ? rawAnon
  : PLACEHOLDER_ANON

export const supabaseConfigured = url !== PLACEHOLDER_URL && anon !== PLACEHOLDER_ANON

if (!supabaseConfigured) {
  console.warn('[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing or placeholder — auth disabled')
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
